import React from 'react'
import {KTSVG} from '../../_metronic/helpers'
import {Product, ProductKey} from '../../services/cellcast.v2.types'

export enum VariantRenderContent {
  MODAL = 'modal',
  PAGE = 'page',
}

type FeatureSplashContentProps = {
  title?: string
  description?: React.ReactNode
  product?: Product
  onActivate?: () => void
  onClose?: () => void
  showCloseButton?: boolean
  variant?: VariantRenderContent
  ctaLabel?: string
  showEmbedVideo?: boolean
  embedVideoUrl?: string
}

const FeatureSplashContent: React.FC<FeatureSplashContentProps> = ({
  description,
  product,
  onActivate,
  onClose,
  showCloseButton = false,
  variant = VariantRenderContent.MODAL,
  ctaLabel,
  showEmbedVideo = false,
  embedVideoUrl = '',
}) => {
  const promoteImageUrl = 'https://prod-wallet-card-config.s3.ap-southeast-2.amazonaws.com/assets/subscription_image_lc.png'
  const containerClass = variant === VariantRenderContent.PAGE ? 'container-fluid py-10' : ''
  const headerClass =
    variant === VariantRenderContent.PAGE
      ? 'd-flex align-items-center justify-content-between mb-8'
      : 'modal-header border-0 pb-0'
  const bodyClass = variant === VariantRenderContent.PAGE ? 'row g-8' : 'modal-body px-8 py-6'

  return (
    <div className={variant === VariantRenderContent.MODAL ? containerClass : ''}>
      {variant === VariantRenderContent.MODAL && (
        <div className={headerClass}>
          <div className='d-flex align-items-center w-100'>
            <h2 className='modal-title fs-2 fw-bold text-gray-900 mb-0'>
              {product?.name || 'Feature'}
            </h2>
            {showCloseButton && onClose && (
              <button
                type='button'
                className='btn btn-icon btn-sm btn-light-dark ms-auto'
                onClick={onClose}
                aria-label='Close'
              >
                <KTSVG className='svg-icon-2' path='/media/icons/duotune/arrows/arr061.svg' />
              </button>
            )}
          </div>
        </div>
      )}

      <div className={variant === VariantRenderContent.MODAL ? bodyClass : 'row g-8'}>
        <div className={`${variant === VariantRenderContent.PAGE ? 'row g-8' : 'row g-8'}`}>
          <div className='col-lg-6'>
            <div className='card border-0 rounded-4 h-100'>
              <div className='card-body px-10 py-8 d-flex flex-column'>
                <div className='mb-8 flex-grow-1'>
                  <div className='text-gray-700 fs-5 lh-lg'>
                    {description || product?.description}
                  </div>
                </div>

                {onActivate && (
                  <div className='text-start mt-auto'>
                    <button
                      className='btn btn-primary btn-lg px-8 py-3 fw-bold'
                      onClick={onActivate}
                    >
                      <i className='bi bi-plus-circle me-2'></i>
                      {ctaLabel || 'Activate Now'}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
          {product?.promoteVideoUrl && product.productKey === ProductKey.BCARD && (
            <div className='col-lg-6 d-flex flex-column'>
              <div className='mb-6 flex-grow-1'>
                <div className='card border-0 rounded-4 overflow-hidden shadow-lg bg-white'>
                <div className='ratio ratio-16x9'>
                    <iframe
                      title='feature-video'
                      src={product.promoteVideoUrl}
                      className='rounded-4'
                      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                      referrerPolicy='strict-origin-when-cross-origin'
                      allowFullScreen
                    />
                  </div>
                </div>
              </div>
            </div>
          )}{' '}
          {product?.promoteImageUrl && product.productKey === ProductKey.LIVECHAT && (
            <div className='col-lg-6 d-flex flex-column'>
              <div className='mb-6 flex-grow-1'>
                <div className='card border-0 rounded-4 overflow-hidden shadow-lg bg-white'>
                  <img
                      src={product.promoteImageUrl || promoteImageUrl}
                      alt={product.name || 'Product feature image'}
                      style={{width: '30.5vw', height: '83vh', objectFit: 'cover'}}
                    />
                </div>
              </div>
            </div>
          )}
          {showEmbedVideo && embedVideoUrl && (
            <div className='col-lg-6 d-flex flex-column'>
              <div className='mb-6 flex-grow-1'>
                <div className='card border-0 rounded-4 overflow-hidden shadow-lg bg-white ratio ratio-16x9'>
                  <iframe src={embedVideoUrl} title='Embedded Video' allowFullScreen style={{width: '100%', height: '100%'}}></iframe>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default FeatureSplashContent
